<course-group-list-header
  [courseId]="courseId"
  [rest]="rest"
  [active]="active"
  [isTeacher]="isTeacher"
  [disabledActions]="disabledActions"
/>
